(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glx-review-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.rcReady) return;
    root.dataset.rcReady = '1';
    var track = root.querySelector('.glx-rc__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.glx-rc__slide'));
    var prev = root.querySelector('[data-rc-prev]');
    var next = root.querySelector('[data-rc-next]');
    var dotsWrap = root.querySelector('.glx-rc__dots');
    if (!track || slides.length === 0) return;
    var stops = [];
    var dots = [];
    var current = 0;
    var timer = null;
    var paused = false;
    var delay = parseInt(root.dataset.autoplay || '0', 10) * 1000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function offsetOf(slide) { return slide.offsetLeft - track.firstElementChild.offsetLeft; }

    function build() {
      var max = track.scrollWidth - track.clientWidth;
      stops = [];
      slides.forEach(function (s) {
        var x = Math.min(offsetOf(s), max);
        if (stops.length === 0 || x - stops[stops.length - 1] > 4) stops.push(x);
      });
      if (stops.length && max - stops[stops.length - 1] > 4) stops.push(max);
      dotsWrap.innerHTML = '';
      dots = stops.map(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'glx-rc__dot';
        b.setAttribute('aria-label', 'Go to review group ' + (i + 1) + ' of ' + stops.length);
        b.addEventListener('click', function () { go(i); restart(); });
        dotsWrap.appendChild(b);
        return b;
      });
      dotsWrap.hidden = stops.length < 2;
      sync();
    }

    function go(i) {
      if (!stops.length) return;
      i = Math.max(0, Math.min(i, stops.length - 1));
      track.scrollTo({ left: stops[i], behavior: reduce ? 'auto' : 'smooth' });
    }

    function sync() {
      var x = track.scrollLeft;
      var best = 0;
      stops.forEach(function (s, i) { if (Math.abs(s - x) < Math.abs(stops[best] - x)) best = i; });
      current = best;
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
        if (i === current) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = current <= 0;
      if (next) next.disabled = current >= stops.length - 1;
    }

    function tick() {
      if (paused || document.hidden) return;
      go(current >= stops.length - 1 ? 0 : current + 1);
    }
    function restart() {
      if (timer) clearInterval(timer);
      if (delay > 0 && !reduce && stops.length > 1) timer = setInterval(tick, delay);
    }

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(current - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(current + 1); restart(); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); restart(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); restart(); }
    });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    track.addEventListener('touchstart', function () { paused = true; restart(); }, { passive: true });
    track.addEventListener('touchend', function () { paused = false; }, { passive: true });

    var rt = null;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(build, 150); });
    build();
    restart();
  }

  function boot() { document.querySelectorAll('[data-glx-rc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-glx-rc]');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
